import {z} from 'zod';

export const ChatAttachmentIdSchema = z.uuid();
export const ChatAttachmentSchema = z.object({
  id: ChatAttachmentIdSchema,
  name: z.string().min(1).max(255),
  size: z.number().int().nonnegative(),
  mediaType: z.string().max(200),
}).strict();
export type ChatAttachment = z.infer<typeof ChatAttachmentSchema>;
/** Verified account-local references; paths and hashes do not enter the public transcript. */
export const ChatAttachmentReferenceSchema = ChatAttachmentSchema.extend({
  path: z.string().regex(/^\/workspace\/uploads\/[0-9a-f-]{36}\/file(?:\.[a-z0-9]{1,12})?$/),
  sha256: z.string().regex(/^[a-f0-9]{64}$/),
}).strict();
export const NativeAttachmentReferenceSchema=ChatAttachmentSchema.extend({
  source:z.literal('native_attachment'),
  path:z.string().startsWith('/'),
  sha256:z.string().regex(/^[a-f0-9]{64}$/),
}).strict();
export const ChatAttachmentUploadSchema = z.object({
  name: z.string().min(1).max(255).refine(value => !/[\x00-\x1f\x7f/\\]/.test(value) && !['.', '..'].includes(value), 'Invalid file name'),
  mediaType: z.string().max(200).regex(/^[\x20-\x7e]*$/),
  size: z.number().int().nonnegative().safe(),
}).strict();
